import { render, staticRenderFns } from "./ForkTab.vue?vue&type=template&id=af08591e"
import script from "./ForkTab.vue?vue&type=script&lang=js"
export * from "./ForkTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports